import api from '../utils/api.utils';

export interface CustomVerificationResponse {
  success: boolean;
  message: string;
  user_verified?: boolean;
}

export const customVerificationService = {
  /**
   * Send custom verification email
   */
  sendVerificationEmail: async (): Promise<CustomVerificationResponse> => {
    const response = await api.post('/api/v1/verification/send-verification', {});
    return response.data;
  },

  /**
   * Verify email using token
   */
  verifyEmailToken: async (token: string): Promise<CustomVerificationResponse> => {
    const response = await api.post('/api/v1/verification/verify', { token });
    return response.data;
  },

  /**
   * Get verification status
   */
  getVerificationStatus: async (): Promise<CustomVerificationResponse> => {
    const response = await api.get('/api/v1/verification/status');
    return response.data;
  },

  /**
   * Verify email using GET method (for email links)
   */
  verifyEmailTokenGet: async (token: string): Promise<CustomVerificationResponse> => {
    const response = await api.get(`/api/v1/verification/verify?token=${token}`);
    return response.data;
  }
};

export default customVerificationService;